import styled from 'styled-components';

import { devices } from 'shared/styles/components';

export const PlanFeaturesItemOfferingContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  margin-top: 0px;

  .description {
    margin: 8px 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;

    @media ${devices.laptopLMax} {
      font-size: 14px;
    }
  }

  svg {
    width: 28px;

    &.included {
      fill: ${({ theme }) => theme.colors.success};
    }
    &.not-included {
      fill: ${({ theme }) => theme.colors.gray700};
    }
  }
`;
